var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_519_147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 0H0.000244141V34H15.0002V0ZM38.0002 0H23.0002V34H38.0002V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 0H0.000244141V34H15.0002V0ZM38.0002 0H23.0002V34H38.0002V0Z",
    fill: "#DFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 0V-3H-2.99976V0H0.000244141ZM15.0002 0H18.0002V-3H15.0002V0ZM0.000244141 34H-2.99976V37H0.000244141V34ZM15.0002 34V37H18.0002V34H15.0002ZM23.0002 0V-3H20.0002V0H23.0002ZM38.0002 0H41.0002V-3H38.0002V0ZM23.0002 34H20.0002V37H23.0002V34ZM38.0002 34V37H41.0002V34H38.0002ZM0.000244141 3H15.0002V-3H0.000244141V3ZM3.00024 34V0H-2.99976V34H3.00024ZM15.0002 31H0.000244141V37H15.0002V31ZM12.0002 0V34H18.0002V0H12.0002ZM23.0002 3H38.0002V-3H23.0002V3ZM26.0002 34V0H20.0002V34H26.0002ZM38.0002 31H23.0002V37H38.0002V31ZM35.0002 0V34H41.0002V0H35.0002Z",
    fill: "#DFF8FF",
    mask: "url(#path-1-inside-1_519_147)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseFullIcon);
export default __webpack_public_path__ + "static/media/pause-full-icon.7e967ad134944e9a7802135dc69b97f4.svg";
export { ForwardRef as ReactComponent };